
    const data = {"name":"src/core/icons/equal","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 10H5V8h14v2m0 6H5v-2h14v2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            